if (typeof $ == 'undefined') {
    var $ = jQuery.noConflict();
}
$(document).ready(function () {
    $('.search__suggest-list li').click(function () {
        $('.boost-pfs-search-box').val($(this).html()).click().focus()
    })
    $('.custom-filter-clear').click(function () {
        $('.boost-pfs-filter-refine-by .boost-pfs-filter-button').click()
    })

    function updateSearchForm() {
        let $searchForm = $('.c-header__search-bar'),$inputSearch = $('.c-header__search-bar .c-header__search-input'), $inputType = $('.c-header__search-bar .c-header__search-type');
        $inputSearch.attr('name', $inputSearch.attr('data-name'));
        $inputType.attr('name', $inputType.attr('data-name'));
        if ($inputSearch.val() !== '') {
            $searchForm.attr('action', '/search');
        } else {
            $searchForm.attr('action', '/collections/all');
        }
    }
    updateSearchForm();
    $(document).on('keyup', 'input.c-header__search-input', updateSearchForm);

    function hideSwatchDropdown() {
        $('.o-swatches__swatch-dropdown').removeClass('active');
        $('.o-swatches__swatch-dropdown .o-swatches__swatch-options').scrollTop(0);
    }
    $(document).on('click', '.o-swatches__swatch-dropdown:not(.active)', function () {
        $(this).addClass('active')
    })
    $(document).on('click', '.o-swatches__swatch-dropdown.active button', function () {
        hideSwatchDropdown();
    })
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.o-swatches__swatch-options').length) {
            hideSwatchDropdown();
        }
    })
    $('.o-swatches__swatch-option').on('click', function() {
        if ($(this).attr('data-price')) {
            $('.c-product-template__price .c-product-template__price-price').html($(this).attr('data-price') + ' ' + $(this).attr('data-currency'));
            $('.c-product-template__price .c-product-template__price-price').attr('data-money', $(this).attr('data-money'));
            $('meta[itemprop="priceCurrency"]').attr('content', $(this).attr('data-currency'));
            $('meta[itemprop="price"]').attr('price', $(this).attr('data-item-price'));
        }
    })

    // Hide when not AU
    let topBar = document.getElementById('topbar')
    if (Shopify.country != 'AU') {
        topBar.style.display = "none"
    }
    $('.btn-change-country').on('click', function() {
        window.location.href = "/?currency=" + $('#location-sl-country li.active').attr("value");
    });
    if (!localStorage.getItem('show-local-popup')) {
        $('.location-popup').show();
    } else {
        $('.location-popup').remove();
        $('.shopify-section-location-popup').css('z-index', -1);
    }
    $('.location-close-modal').on('click', function() {
        $('.location-popup').remove();
        $('.shopify-section-location-popup').css('z-index', -1);
        localStorage.setItem('show-local-popup', true);
    });
    $(document).click(function(event) {
        if (!$(event.target).closest(".location-popup").length) {
            $('.location-popup').remove();
            localStorage.setItem('show-local-popup', true);
            $('.shopify-section-location-popup').css('z-index', -1);
        }
    });
    $('.btn-change-country-init').on('click', function() {
        $('.location-detail').hide();
        $('.location-popup .flag').hide();
        $('.select-country').show();
    });
    $('.btn-go-back').on('click', function() {
        $('.location-detail').show();
        $('.location-popup .flag').show();
        $('.select-country').hide();
    });
    $('.btn-continue').on('click', function() {
        $('.location-popup').remove();
        $('.shopify-section-location-popup').css('z-index', -1);
    });
    $('.select-country-label').on('click', function() {
        $('.location-popup').toggleClass('active');
        $('.location-popup .location-sl-country').toggle();
    });
    $('.location-sl-country li').on('click', function() {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    });
})
window.addEventListener('load', function() {
    $('.sc-selectbox__option').on('click', function() {
        var currentValue = $(this).html()
        currentValue = currentValue.trim()
        $('.o-swatches__swatch-option').each(function(){
            if ($(this).html().trim() == currentValue || $(this).attr('data-value').trim() == currentValue) {
                $(this).click();
            }
        })
    })
})
